import { Injectable } from '@angular/core';

import { Buffer } from 'buffer';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import Constants from '../constants/constants';

import { SessionService } from './session.service';
@Injectable({
  providedIn: 'root',
})
export class UtilService {
  subjectChange = new BehaviorSubject<number>(0);
  siteChangeSubject = new BehaviorSubject<string>('');
  siteReloadSubject = new BehaviorSubject<string>('');
  recommendationReloadSubject = new BehaviorSubject<boolean>(false);

  constructor(private sessionService: SessionService) {}

  // Set the value of the subjectChange
  setSubjectChange(value: number) {
    this.subjectChange.next(value);
  }

  // Get the value of the subjectChange
  getSubjectChange() {
    return this.subjectChange.asObservable();
  }

  setSiteChange(value: string) {
    this.siteChangeSubject.next(value);
  }

  /**
   * @description Get the site change
   * @returns Observable<string>
   */
  get getSiteChange(): Observable<string> {
    return this.siteChangeSubject.asObservable();
  }

  /**
   * @description Set the site reload
   * @param value string
   */
  setSiteReload(value: string) {
    this.siteReloadSubject.next(value);
  }

  onSiteReload(): Observable<string> {
    return this.siteReloadSubject.asObservable();
  }

  setRecommendationReload(value: boolean) {
    this.recommendationReloadSubject.next(value);
  }

  onRecommendationReload(): Observable<boolean> {
    return this.recommendationReloadSubject.asObservable();
  }

  /**
   *
   * @param value: number
   * @description Creating a boolean function to determine if a number is a decimal or a whole number
   * @returns boolean
   */
  isDecimalValue(value: number): boolean {
    return value % 1 === 0 ? false : true;
  }

  /**
   * @description Redirection link to the DFS
   * @param payload any
   * @returns string
   */
  encodeRedirectionLink(payload: any): string {
    return (
      environment.dfsUrl +
      '/auth?redirect=' +
      encodeURIComponent(
        Buffer.from(JSON.stringify(payload)).toString('base64')
      )
    );
  }

  /**
   *
   * @description Get the host name from the session and split it to get the first two parts of the host name
   * @returns string
   */
  get host(): string {
    const hostName =
      this.sessionService.getItemFromSession(Constants.CONFIG.INFO)?.host ||
      window.location.host;

    // Split the host name to get the first two parts of the host name
    const hostSplit = hostName?.split('.');
    // For Local
    if (hostName === 'localhost:4200') {
      return './assets/images/whitelabel/energyhelp/';
      // energyhelp
      // consultivutilitiesenergyhelp
      // advantageutilitiesenergyhelp
      // jlmelectricalenergyhelp
      // utilityaidenergyhelp
      // greenbusinessactionenergyhelp
      // zirconenergyhelp
    } else {
      if (hostSplit?.length > 3) {
        // Check if the length of the hostSplit is greater than 3. If it is, return the first two parts of the host name.
        return (
          environment?.assets + hostSplit[0] + '/' + hostSplit[1] + '/images/'
        );
      } else {
        // If the length of the hostSplit is not greater than 3, return the first part of the host name.
        return environment?.assets + hostSplit[0] + '/prod/images/';
      }
    }
  }

  get config(): any {
    const hostName =
      this.sessionService.getItemFromSession(Constants.CONFIG.INFO)?.host ||
      window.location.host;
    const hostSplit = hostName?.split('.');
    // For Local
    if (hostName === 'localhost:4200') {
      return './assets/json/energyhelp/config.json';
      // energyhelp
      // consultivutilitiesenergyhelp
      // advantageutilitiesenergyhelp
      // jlmelectricalenergyhelp
      // utilityaidenergyhelp
      // greenbusinessactionenergyhelp
    } else {
      return environment?.assets + hostSplit[0] + '/json/config.json';
    }
  }

  /**
   * @description Configure the application
   */
  configureApplication(): void {
    const configuration = this.sessionService.getItemFromSession(
      Constants.CONFIG.INFO
    )?.config;

    if (!!configuration) {
      Object.keys(configuration).forEach((key) => {
        document.documentElement.style.setProperty(
          `--${key}`,
          configuration[key]
        );
        document.documentElement.style.setProperty(
          `--${key}`,
          configuration[key]
        );
      });
    }
  }

  /**
   * Save or download file from `Blob` object
   * 
   * @param {Blob|MediaSource} blob - The `Blob` or `MediaSource` object to be downloaded.
   * @param {string} filename - The name of the file to be saved.
   * @returns {void}
   */
  saveFile(blob: Blob | MediaSource, filename: string): void {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  }

  getMeterType(profileClass: string): string{
    return Constants.METER_PROFILE[profileClass]
  }

  /**
   * URL encode values from object
   * @param obj Key value pair object
   * @returns {string}
   */
  encodeURLParams(obj:any = {}): string{
    return Object.keys(obj).map(el => {
      return `${el}=${encodeURIComponent(obj[el])}`
    }).join('&');    
  }
}